document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-menu-toggle]');
  if (!button) return;
  const menu = document.querySelector('[data-mobile-menu]');
  const open = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!open));
  menu.hidden = open;
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const form = event.target.closest('[data-product-form]');
  if (form && option) form.querySelector('[name="id"]').value = option.value;
});
